"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getProjectRole () {
        return _nocodbsdk.getProjectRole;
    },
    get getProjectRolePower () {
        return getProjectRolePower;
    },
    get hasMinimumRole () {
        return hasMinimumRole;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("src/helpers/catchError");
function getProjectRolePower(user) {
    return (0, _nocodbsdk.extractProjectRolePower)(user, ()=>{
        _catchError.NcError.badRequest('Forbidden');
    });
}
function hasMinimumRole(user, minimumRole) {
    return (0, _nocodbsdk.hasMinimumRoleAccess)(user, minimumRole, ()=>{
        _catchError.NcError.badRequest('Forbidden');
    });
}
